export const stickerCategories = [
    'giphytrending',
    'giphyfavorites',
    'effects',
    'emoji',
    'accessories',
    'party',
    'holidays',
] as const

type StickerCategory = typeof stickerCategories[number]

export function categoryTitle(category: StickerCategory): string {
    switch (category) {
        case 'accessories':
            return 'Accessories'
        case 'effects':
            return 'Effects'
        case 'emoji':
            return 'Emoji'
        case 'giphyfavorites':
            return 'Favs'
        case 'giphytrending':
            return 'Trending'
        case 'holidays':
            return 'Holidays'
        case 'party':
            return 'Party'
    }
}

export function categoryFromSearchTerm(term: string): StickerCategory | null {
    switch (term) {
        case 'accessories':
            return 'accessories'
        case 'effects':
            return 'effects'
        case 'emoji':
            return 'emoji'
        case 'giphyfavorites':
            return 'giphyfavorites'
        case 'giphytrending':
            return 'giphytrending'
        case 'holidays':
            return 'holidays'
        case 'party':
            return 'party'
        default:
            return null
    }
}

export default StickerCategory
